import { render } from "./ComplexSelect.vue?vue&type=template&id=797942ba"
import script from "./ComplexSelect.vue?vue&type=script&lang=js"
export * from "./ComplexSelect.vue?vue&type=script&lang=js"

import "./ComplexSelect.vue?vue&type=style&index=0&id=797942ba&lang=scss"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__